export const MAX_STAKE_DURATION = 7 * 12;
